// extracted by mini-css-extract-plugin
module.exports = {"link":"R8zaM","itemNameLink":"_2Pk9X","root":"_25ygu","inline":"_1OE9d","itemName":"_2WWZB","authorAndCategory":"JHf2a"};